import React, { useState, useEffect } from "react";
import { Link as ScrollLink } from "react-scroll";
import "./Header.css";
import VisitorCounter from "../VisitorCounter";
const Header = ({ toggle }) => {
  const [scrolled, setScrolled] = useState(false);
  
  // Add scroll event listener to create header animation on scroll
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  
  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <div className="logo">
          <a href="/">
            <img src="/IMG_3369.png" alt="Dibyanjaya Panda" />
          </a>
        </div>
        
        <nav className="nav-menu">
          <ScrollLink 
            className="nav-item"
            to="projects"
            smooth={true}
            duration={500}
            spy={true}
            activeClass="active"
          >
            Projects
          </ScrollLink>
          
          <ScrollLink 
            className="nav-item"
            to="about"
            smooth={true}
            duration={500}
            spy={true}
            activeClass="active"
          >
            About
          </ScrollLink>
          
          <ScrollLink 
            className="nav-item"
            to="contact"
            smooth={true}
            duration={500}
            spy={true}
            activeClass="active"
          >
            Contact
          </ScrollLink>
          
          <a
            className="nav-item external"
            href="/blog"
            target="_blank"
            rel="noopener noreferrer"
          >
            Blog
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
              <polyline points="15 3 21 3 21 9"></polyline>
              <line x1="10" y1="14" x2="21" y2="3"></line>
            </svg>
          </a>
        </nav>
        
        <div className="nav-actions">
          {/* Visitor Counter Component */}
          <VisitorCounter />
          
          <a
            className="resume-button"
            href="/Dibyanjaya_Panda.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            Resume
          </a>
          
          <button className="menu-toggle" onClick={toggle} aria-label="Toggle menu">
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;